import { useTranslation } from "react-i18next";
import Menu from "src/components/Menu";
import MenuItem from "src/components/Menu/Item";
import MenuItemText from "src/components/Menu/ItemText";
import { ReactComponent as MoreIcon } from "src/icons/more-vert.svg";

function DeviceMenu({ isOpen, onClose, onRename, onRemove, onOpen }) {
  const { t } = useTranslation();
  return (
    <Menu
      elevationLevel={2}
      isOpen={isOpen}
      onOpen={onOpen}
      onClose={onClose}
      icon={MoreIcon}
    >
      {onRename && (
        <MenuItem onClick={onRename}>
          <MenuItemText>{t("buttons.rename")}</MenuItemText>
        </MenuItem>
      )}
      {onRemove && (
        <MenuItem onClick={onRemove}>
          <MenuItemText>{t("buttons.delete")}</MenuItemText>
        </MenuItem>
      )}
    </Menu>
  );
}

export { DeviceMenu };
